import { useEffect, useState } from 'react';
import { ChevronRight, Type } from 'lucide-react';
import { clsx } from '../../utils/cn.js';
import { useFontScale } from '../../hooks/useFontScale.js';

const PANEL_VISIBLE_KEY = 'coonaltragas_font_panel_visible';

const btnClass =
  'flex h-10 w-10 items-center justify-center text-sm font-bold transition disabled:cursor-not-allowed disabled:opacity-40';

const shellClass =
  'overflow-hidden rounded-xl border border-slate-200/90 bg-white/95 text-black shadow-[0_8px_28px_rgba(13,43,127,0.18)] ring-1 ring-[#0d2b7f]/10 backdrop-blur-sm';

function readPanelVisible() {
  try {
    return localStorage.getItem(PANEL_VISIBLE_KEY) !== '0';
  } catch {
    return true;
  }
}

export default function FontSizeFloatingButton() {
  const { scale, increase, decrease, canIncrease, canDecrease } = useFontScale();
  const [open, setOpen] = useState(readPanelVisible);

  useEffect(() => {
    try {
      localStorage.setItem(PANEL_VISIBLE_KEY, open ? '1' : '0');
    } catch {
      /* ignore */
    }
  }, [open]);

  return (
    <div className="fixed right-3 top-1/2 z-50 -translate-y-1/2 sm:right-5">
      {open ? (
        <div className={clsx('flex flex-col', shellClass)} role="group" aria-label="Tamaño del texto">
          <div className="flex items-center justify-center border-b border-slate-100 bg-[#0d2b7f]/5 py-2">
            <Type className="h-4 w-4 text-[#0d2b7f]" strokeWidth={2} aria-hidden />
          </div>
          <button
            type="button"
            onClick={increase}
            disabled={!canIncrease}
            className={clsx(btnClass, 'hover:bg-[#1acb12]/15')}
            aria-label="Aumentar tamaño de letra"
            title="Aumentar tamaño de letra"
          >
            A+
          </button>
          <span
            className="border-y border-slate-100 bg-slate-50 px-2 py-1 text-center text-[10px] font-semibold tabular-nums text-slate-600"
            aria-live="polite"
            aria-atomic="true"
          >
            {scale}%
          </span>
          <button
            type="button"
            onClick={decrease}
            disabled={!canDecrease}
            className={clsx(btnClass, 'hover:bg-slate-100')}
            aria-label="Disminuir tamaño de letra"
            title="Disminuir tamaño de letra"
          >
            A−
          </button>
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="flex h-9 w-10 items-center justify-center border-t border-slate-100 text-slate-500 transition hover:bg-slate-100 hover:text-[#0d2b7f]"
            aria-label="Ocultar controles de texto"
            title="Ocultar"
          >
            <ChevronRight className="h-4 w-4" strokeWidth={2} aria-hidden />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className={clsx(
            shellClass,
            'flex h-11 w-11 items-center justify-center transition hover:bg-[#0d2b7f]/5'
          )}
          aria-label="Mostrar controles de tamaño de texto"
          title="Tamaño del texto"
        >
          <Type className="h-5 w-5 text-[#0d2b7f]" strokeWidth={2} aria-hidden />
        </button>
      )}
    </div>
  );
}
